// Components
import { forgottenPass } from './components/dialog-forgottenPass';

// Layout
import { layoutLeftSide } from './layouts/layoutLeftSide.js';
import { layoutHeader } from './layouts/layoutHeader.js';

// Main pages
import { form } from './pages/form.js';
import { signin } from './pages/signin.js';
import { signup } from './pages/signup.js';
import { users } from './pages/users';
import { contact } from './pages/contact';
import { changelog } from './pages/changelog';

// Generic words
import { generic } from './pages/generic.js';

export default {
  // Generic
  generic,

  // Components
  forgottenPass,

  // Layouts
  layoutLeftSide,
  layoutHeader,

  // Pages
  form,
  signin,
  signup,
  users,
  contact,
  changelog,
};
